import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MainSearchService } from 'src/app/core/services/main-search.service';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';

@Component({
  selector: 'main-search-results',
  templateUrl: './main-search-results.component.html',
  styleUrls: ['./main-search-results.component.scss']
})
export class MainSearchResultsComponent implements OnInit {

	constructor(
		public mainSearchService: MainSearchService,
		private router: Router,
		public ml: MultiLanguageService
	) { }

	ngOnInit() {
	}

	closeSearch(){
		this.mainSearchService.clearSearch();
	}	
}
